export default "__VITE_ASSET__Df2IF2hr__"